import { StepType } from "../../../Enums/StepType";

export class MailManagementCreateModel {
  public To?: string;
  public Cc?: string;
  public Subject?: string;
  public Body?: string;
  public IsCustomer?: boolean;
  public StepTypeEnum?: StepType;
  public CustomerId?: number;
  public IsMailFreeze?: boolean;
}
